var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 54,
    viewBox: "0 0 69 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0V54L9.5 26.5L27 0ZM17 0L0 26.5L17 54H0V0H17Z",
    fill: "#092F2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H38.1325H53.1759C61.9153 0 69 7.08467 69 15.8241C69 24.4222 62.1343 31.447 53.5384 31.644L38 32V54H27V0Z",
    fill: "#FE850B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4867 7.0001C48.2616 7.00359 48.047 7.09536 47.8902 7.25528C47.7333 7.4152 47.6469 7.6302 47.65 7.8531V8.73897C44.7954 8.94974 43.2701 10.1778 42.4919 11.2191H54.5081C53.7299 10.1778 52.2046 8.94974 49.35 8.73897V7.8531C49.3516 7.74052 49.3303 7.62877 49.2874 7.52448C49.2446 7.42018 49.181 7.32546 49.1005 7.24592C49.02 7.16638 48.9242 7.10364 48.8188 7.06142C48.7134 7.01919 48.6004 6.99834 48.4867 7.0001ZM40.85 12.9021C40.3808 12.9021 40 13.2791 40 13.7436C40 14.2081 40.3808 14.5851 40.85 14.5851C41.3192 14.5851 41.7 14.962 41.7 15.4266V20.4755C41.7 21.8699 42.8416 23 44.25 23H52.75C54.1585 23 55.3 21.8699 55.3 20.4755V15.4266C55.3 14.962 55.6808 14.5851 56.15 14.5851C56.6192 14.5851 57 14.2081 57 13.7436C57 13.2791 56.6192 12.9021 56.15 12.9021H40.85Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23H27V32H38V23Z",
    fill: "#092F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitplay);
export default __webpack_public_path__ + "static/media/kitplay.00659141a519e7ec1134bf4d6744213c.svg";
export { ForwardRef as ReactComponent };